import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const WeekendFilterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('50')};
    line-height: 1;
`;
